import React from "react";
import type { PendingReview } from "../../../chat/hooks/useStreamingTurn";
import { EmailApprovalCard } from "./EmailApprovalCard";
import { PromoteApprovalCard } from "./PromoteApprovalCard";

export interface ToolApprovalCardProps {
  review: PendingReview;
  onDecide: (decision: "approve" | "reject") => void | Promise<void>;
}

/** The approval card for whichever gated tool the turn stopped on. Each gated
 *  tool needs its own card: an email-shaped frame around another call would
 *  describe something other than what approving runs. */
export function ToolApprovalCard({ review, onDecide }: ToolApprovalCardProps) {
  if (review.tool_name === "promote_to_knowledge") {
    return <PromoteApprovalCard review={review} onDecide={onDecide} />;
  }
  return <EmailApprovalCard review={review} onDecide={onDecide} />;
}
